import { useEffect, useRef, useState } from 'react';

import { Text, TextProps, Tooltip } from '@fly/core';
import cn from 'classnames';

export function FlyTextOverflow({
  children,
  content,
  ...props
}: TextProps & { content?: React.ReactNode }) {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  // Show tooltip only if text is overflowing
  useEffect(() => {
    const element = textRef.current;

    if (!element) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        setIsOverflowing(entry.target.scrollWidth > entry.target.clientWidth);
      }
    });

    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Tooltip
      content={content || children}
      open={isOverflowing ? undefined : false}
      selectable
    >
      <Text
        as='div'
        {...props}
        className={cn(
          props.className,
          'truncate',
          isOverflowing && 'cursor-pointer'
        )}
        ref={textRef}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
